import { useTheme, useMediaQuery } from '@mui/material';

// Shared with anywhere else that lays out recipe cards in a grid (e.g. the
// meal-plan add modal) so column count and spacing stay in lockstep with the
// main list.
// What a card image actually occupies at each breakpoint, for the browser to
// size its srcset pick against. Kept next to the column count it is derived
// from: 2 columns below md, then 3, 4 and 5, inside a page capped at
// PAGE_MAX_WIDTH (1600px, so a fifth of it once xl is reached).
export const RECIPE_CARD_IMAGE_SIZES =
  '(max-width: 900px) 50vw, (max-width: 1200px) 33vw, (max-width: 1536px) 25vw, 320px';

export function useRecipeGridColumns() {
  const theme = useTheme();  
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  const columns = isMobile ? 2 : isXl ? 5 : isLg ? 4 : 3;
  
  const gap = isMobile ? 10 : 16;

  return { columns, gap, isMobile };
}
